<template>
  <div >
    <m-counting/>
    <m-total-records />
    <m-save-order />
    <m-place-order-tax />
    <m-save-quick-pick />
    <m-send-quote />
    <m-data-use-agreement />
    <m-sample-example />

    <order1 v-if="uiVersion === 1">
      <slot/>
    </order1>

    <order2  v-if="uiVersion === 2">
      <slot></slot>
    </order2>
  </div>
</template>

<script>
  import Order1 from '@/pages/order/Order1'
  import Order2 from '@/pages/order/Order2'
  import MCounting from '@/components/summary/MCounting'
  import MSaveOrder from '@/components/summary/MSaveOrder'
  import MPlaceOrderTax from '@/components/summary/MPlaceOrderTax'
  import MSaveQuickPick from '@/components/demo/MSaveQuickPick'
  import MSendQuote from '@/components/summary/MSendQuote'
  import MDataUseAgreement from '@/components/summary/MDataUseAgreement'
  import MTotalRecords from '@/components/demo/MTotalRecords'
  import MSampleExample from '@/components/common/MSampleExample.vue'

  export default {
    components: {
      Order1,
      Order2,
      MCounting,
      MSampleExample,
      MSaveOrder,
      MPlaceOrderTax,
      MSaveQuickPick,
      MSendQuote,
      MDataUseAgreement,
      MTotalRecords
    },
    props: {
    },
    created () {
      let listType = parseInt(this.$route.params.listType)

      this.$store.dispatch('demo/init', listType)
      // init savelistcount
      console.log(this.$route.query.FromGateway)
      if (this.$route.query.FromGateway) {
        this.getOrderFromSession()
        this.$store.commit('site/saveKey', ['isSCL', true])
      } else {
        this.$store.dispatch('order/initOrder', listType)
      }
      // init recommend
      // this.getRecommendDemo()
    },
    watch: {
      '$route.params.listType' () {
        let listType = parseInt(this.$route.params.listType)

        if (!this.$store.getters['config/checkDatasource'](listType)) {
          this.$router.replace({name: 'landing'})
        } else if (listType !== this.$store.state.order.ListType) {
          this.$store.dispatch('order/initOrder', listType)
          this.$store.dispatch('demo/init', listType)

          if (this.$route.name === 'summary') {
            // @TODO need add some notice about this
            this.$router.replace({name: 'order'})
          }
        }
      }
    },
    computed: {
      uiVersion () {
        return this.$store.state.config.uiVersion
      }
    },
    methods: {
      getOrder () {
        // TODO@PONY no need this way
        if (this.getCountId) {
          this.$store.dispatch('order/getOrderAndCount', this.getCountId)

          this.$store.commit('summary/saveKey', ['getCountId', false])
        }
      },
      getRecommendDemo () {
        if (this.recommendDemos.length > 0) {
          for (let demo of this.recommendDemos) {
            this.$store.commit('order/addNewDemo', demo)
          }
          this.$store.commit('demo/saveKey', ['recommendDemos', []])
        }
      },
      getOrderFromSession () {
        this.$http.post('PlaceOrder.aspx/GetOrderFromSession', {}).then(
          resp => {
            if (resp.body.d.ResultFlag) {
              this.$store.commit('order/saveOrder', resp.body.d.DataSource)
              this.$store.dispatch('order/slcPollOrder')
            }
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/order/Order.vue